import { useState } from "react";
import { getStoredAccountType } from "../auth";
import { AllInvoicesPage } from "./AllInvoicesPage";
import { EnterpriseAllInvoicesPage } from "./EnterpriseAllInvoicesPage";
import { HospitalViewInvoicesPage } from "./HospitalViewInvoicesPage";

export function InvoicesPageRouter() {
  const [accountType] = useState(() => getStoredAccountType());

  if (accountType === "enterprise") {
    return <EnterpriseAllInvoicesPage />;
  }

  if (accountType === "hospital") {
    return <HospitalViewInvoicesPage />;
  }

  return <AllInvoicesPage />;
}
